import { isSafari as deskSafari } from 'react-device-detect'

export const isSafari = deskSafari
